module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changes_transmitted":"Your changes have been correctly transmitted to the server"},"fr":{"changes_transmitted":"Vos changements ont bien été transmis au serveur"}}')
  delete Component.options._Ctor
}
